import { type FunctionComponent } from "react";
import clsx from "clsx";
import IconFb from "../Icon/IconFb";
import IconInsta from "../Icon/IconInsta";
import IconX from "../Icon/IconX";
import IconLine from "../Icon/IconLine";
import IconYt from "../Icon/IconYt";
import type { PubUserType } from "~/database/user.model";
import IconOfficial from "../Icon/IconOfficial";

interface UserSnsListProps {
  user: PubUserType
}

const UserSnsList: FunctionComponent<UserSnsListProps> = ({
  user
}) => {
  return (
    <div className={clsx("flex", "items-center", "gap-14")}>
      {[
        {
          val: user.official_link,
          icon: <IconOfficial color="#000"></IconOfficial>,
          text: "公式サイト",
        },
        {
          val: user.facebook_link,
          icon: <IconFb color="#000"></IconFb>,
          text: "Facebook",
        },
        {
          val: user.instagram_link,
          icon: <IconInsta color="#000"></IconInsta>,
          text: "Instagram",
        },
        {
          val: user.x_link,
          icon: <IconX color="#000"></IconX>,
          text: "X",
        },
        {
          val: user.line_link,
          icon: <IconLine color="#000"></IconLine>,
          text: "Line",
        },
        {
          val: user.youtube_link,
          icon: <IconYt color="#000"></IconYt>,
          text: "YouTube",
        },
      ]
        .filter((el) => !!el.val)
        .map((el, i) => {
          return (
            <a href={el.val} target="_blank" rel="noreferrer" key={i}>
              <div className={clsx("w-20")}>{el.icon}</div>
            </a>
          );
        })}
    </div>
  );
};

export default UserSnsList;
